export default __webpack_public_path__ + "static/media/image.766a9067.svg";